import { forwardRef } from 'react';
import { Search, Loader2 } from 'lucide-react';
import { Input } from '@/components/atoms/input';
import { cn } from '@/lib/utils';

interface SearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  loading?: boolean;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ loading, className, ...props }, ref) => {
    return (
      <div className="relative">
        <Search
          size={13}
          className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
        />
        <Input ref={ref} type="text" className={cn('pl-8', className)} {...props} />
        {loading && (
          <Loader2
            size={13}
            className="absolute right-2.5 top-1/2 -translate-y-1/2 animate-spin text-muted-foreground"
          />
        )}
      </div>
    );
  },
);
SearchInput.displayName = 'SearchInput';
